import {IChunkSizeProvider} from "./config";

export class ChunkSizeProvider implements IChunkSizeProvider {
  getChunkSize() {
    // Amazon S3 requires minimum chunk size of 5MB
    return 5242880;
  }
}
